import { useState, useEffect } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import FireSafetySection from "@/components/FireSafetySection";
import AboutSection from "@/components/AboutSection";
import ArboristSection from "@/components/ArboristSection";
import ServiceAreasSection from "@/components/ServiceAreasSection";
import PricingSection from "@/components/PricingSection";
import HOACommercialSection from "@/components/HOACommercialSection";
import MaintenanceContractsSection from "@/components/MaintenanceContractsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F9F5]" data-testid="homepage">
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <ServicesSection />
      <FireSafetySection />
      <AboutSection />
      <ArboristSection />
      <HOACommercialSection />
      <MaintenanceContractsSection />
      <ServiceAreasSection />
      <PricingSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
